/* raporty */

//checkAll - cb ktory zaznacza wszystkie checkboxy z danego filtra, checkSetClass - nazwa klasy przypisanej do poszczegolnych checkboxow danego filtra
//przy kliknieciu zaznacz wszystko funkcja zaznacza wszystkie checkboxy w filtrze plus ustawia odpowiedni styl
function markAllCbReport(checkAll, checkSetClass) {
  $.each($("." + checkSetClass), function (i, val) {
    val.checked = checkAll.checked;
    changeCbReportStyle(val, null, checkSetClass);
  });
}

//przy zaznaczeniu/odznaczeniu checkboxa w filtrrze - zaznacza/odznacza checkboxa 'zaznacz wszystkie' oraz ustawia styl
function changeCbReportStyle(cb, checkAll, checkSetClass) {
  setCBReportBGColor(cb);

  if (checkAll != null) {
    if ($("." + checkSetClass).filter(":not(:checked)").length === 0)
      checkAll.checked = true;
    else checkAll.checked = false;
  }
}

//ustawienie stylu zaznaczonego/odznaczonego checkboxa
function setCBReportBGColor(cb) {
  if (cb.checked) {
    cb.parentElement.style.backgroundColor = "#F4F8C2";
  } else {
    cb.parentElement.style.backgroundColor = "";
  }
}

function setAllBGColors(cbClass) {
  $.each($("." + cbClass), function (i, val) {
    setCBReportBGColor(val);
  });
}

function Today() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }

  return mm + "-" + dd + "-" + yyyy;
}

function BuildCSV(fileName, club1) {
  var text = "";

  $(".reportTable").each(function () {
    text = text + $(this).attr("id") + "\n";
    text = text + $(this).toCSV();
    text = text + "\n\n";
  });
  //var uri = 'data:application/csv;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(text);
  var filename = fileName;
  var club = club1;
  filename = filename.replace("&#243;", "ó");
  filename = filename + " " + Today() + "_" + club + ".csv";

  var csvData = new Blob(["\ufeff", text], { type: "text/csv" });
  var csvUrl = URL.createObjectURL(csvData);
  //a.href = csvUrl;

  $(".exportCSV").attr({ download: filename, href: csvUrl, target: "_blank" });
}

function replaceNbsps(str) {
  return str.replace(/&nbsp;/g, " ");
}

function process_stylesheet(ss) {
  try {
    // In Chrome, if stylesheet originates from a different domain,
    // ss.cssRules simply won't exist. I believe the same is true for IE, but
    // I haven't tested it.
    //
    // In Firefox, if stylesheet originates from a different domain, trying
    // to access ss.cssRules will throw a SecurityError. Hence, we must use
    // try/catch to detect this condition in Firefox.
    if (!ss.cssRules) return;
  } catch (e) {
    // Rethrow exception if it's not a SecurityError. Note that SecurityError
    // exception is specific to Firefox.
    if (e.name !== "SecurityError") throw e;
    return;
  }

  // ss.cssRules is available, so proceed with desired operations.
  for (var i = 0; i < ss.cssRules.length; i++) {
    var rule = ss.cssRules[i];
    // Do something with rule
  }
}

function BuildPDF(commandName, commandValue, formId) {
  var html = $("#aboveRows").html();

  $("#pdfText").val(html);
  //SubmitDownload(commandName, commandValue, formId);

  //$('.report-header').each(function () {
  //    text += $(this).toHeaderCSV();
  //});
  //$('.reportTable').each(function () {
  //    text = text + $(this).attr('id') + "\n";
  //    text = text + $(this).toCSV();
  //    text = text + "\n\n";
  //});
  //$('.report-footer').each(function () {
  //    //text += $(this).toFooterCSV();
  //    text += "<footer>";
  //    text += $(this).toCSV();
  //    text += "</footer>";
  //});
  //$("#csvText").val(text);
  SubmitDownload(commandName, commandValue, formId);
}

function BuildCSVReckoningMarkUp(fileName) {
  var text = "";

  $(".report-sale").each(function () {
    text = text + $(this).attr("id") + "\n";
    text = text + $(this).toCSV();
    text = text + "\n\n";
  });
  text = text.replaceAll(".", ",");
  var saleHeader = $("#sale-header").html();
  text = text.replace("undefined", saleHeader);

  $(".report-return").each(function () {
    text = text + $(this).attr("id") + "\n";
    text = text + $(this).toCSV();
    text = text + "\n\n";
  });
  text = text.replaceAll(".", ",");
  var returnHeader = $("#return-header").html();
  text = text.replace("undefined", returnHeader);

  $(".report-total").each(function () {
    text = text + $(this).attr("id") + "\n";
    text = text + $(this).toCSV();
    text = text + "\n\n";
  });
  text = text.replaceAll(".", ",");
  var totalHeader = $("#total-header").html();
  text = text.replace("undefined", totalHeader);

  $(".report-mark-up").each(function () {
    text = text + $(this).attr("id") + "\n";
    text = text + $(this).toCSV();
    text = text + "\n\n";
  });
  text = text.replaceAll(".", ",");
  var reportHeader = $("#markup-header").html();
  text = text.replace("undefined", reportHeader);
  text += $("#mark-up-word").html() + ": " + $("#Mark-Up-Value").val() + " %";
  var uri =
    "data:application/csv;charset=UTF-8,%EF%BB%BF" + encodeURIComponent(text);
  var filename = fileName;
  filename = filename.replace("&#243;", "ó");
  filename = filename + " " + Today() + ".csv";
  $(".exportCSVMarkUp").attr({
    download: filename,
    href: uri,
    target: "_blank",
  });
}

function SubmitDownload(commandName, commandValue, formId) {
  var hidden = document.createElement("input");
  hidden.type = "hidden";
  hidden.name = commandName;
  hidden.value = commandValue;
  document.getElementById(formId).appendChild(hidden);
  document.getElementById(formId).target = "_blank";
  document.getElementById(formId).submit(); // Submit the page
  return true;
}

function SubmitLayoutEditor(
  commandName,
  commandValue,
  formId,
  commandValue1,
  commandValue2,
  commandValue3,
  target
) {
  commandValue = commandValue.trim();
  commandValue1 = commandValue1.trim();
  commandValue2 = commandValue2.trim();
  commandValue3 = commandValue3.trim();
  $('input[type="hidden"][value="' + commandValue1 + '"]').remove();
  $('input[type="hidden"][value="' + commandValue2 + '"]').remove();
  $('input[type="hidden"][value="' + commandValue3 + '"]').remove();
  var hidden = document.createElement("input");
  hidden.type = "hidden";
  hidden.name = commandName;
  hidden.value = commandValue;
  document.getElementById(formId).appendChild(hidden);
  document.getElementById(formId).target = target;
  document.getElementById(formId).submit(); // Submit the page
  return true;
}

function dtLocalization() {
  var name = "_culture=";
  var ca = document.cookie.split(";");
  var value = "";
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) != -1) value = c.substring(name.length, c.length);
  }
  if (value == "en-US") value = "";
  if (value == "nn-NO") value = "no-NN";
  value = value.split("-")[0];
  return String(value);
}

$(document).ajaxComplete(function () {
  $(".collapsible").collapsible();
  $("select:not(.searchEnum)").material_select();
});
$(document).ready(function () {
  $(".modal-trigger").leanModal(); // popup
  $("select").material_select();

  $(".dropdown-button").dropdown({
    inDuration: 300,
    outDuration: 225,
    constrain_width: false, // Does not change width of dropdown to that of the activator
    hover: false, // Activate on hover
    gutter: 0, // Spacing from edge
    belowOrigin: true, // Displays dropdown below the button
  });

  // set all checkboxes in checkbox list assigned to switch
  $("body").on("change", ".checkbox-list-switch", function () {
    var $this = $(this),
      $list = $this.closest(".checkbox-list"),
      $checkboxes = $list.find(":checkbox");

    $checkboxes.prop("checked", $this.is(":checked"));
  });

  // set all checkboxes in checkbox group assigned to switch
  $("body").on("change", ".checkbox-list-advanced-switch", function () {
    var $this = $(this),
      $list = $this.closest(".checkbox-list-advanced"),
      $checkboxes = $list.find("." + this.id + ":checkbox");

    $checkboxes.prop("checked", $this.is(":checked"));
  });

  // refresh switches of all lists that checkbox belongs to
  $("body").on("change", ".checkbox-list :checkbox", function () {
    var $this = $(this),
      $lists = $this.parents(".checkbox-list");
    $lists.each(function () {
      var $list = $(this),
        $switch = $list.find(".checkbox-list-switch").first(),
        $unchecked = $list.find(
          ":not(.checkbox-list-switch):not(.checkbox-list-advanced-switch):checkbox:unchecked"
        );
      $switch.prop("checked", $unchecked.length == 0);
    });
  });

  // refresh switches of all groups that checkbox belongs to
  $("body").on("change", ".checkbox-list-advanced :checkbox", function () {
    var $this = $(this),
      $list = $this.parents(".checkbox-list-advanced").first();
    groups = $this.attr("class").split(/\s+/);

    $.each(groups, function (i, group) {
      var $switch = $list.find("#" + group),
        $unchecked = $list.find(
          "." +
            group +
            ":not(.checkbox-list-switch):not(.checkbox-list-advanced-switch):checkbox:unchecked"
        );
      $switch.prop("checked", $unchecked.length == 0);
    });
  });

  (function fixedActionButton() {
    var $item = $(".fixed-action-btn");
    if ($item.length != 0) {
      var $win = $(window),
        $bottomPos = parseInt($item.css("bottom").replace(/[^-\d\.]/g, ""));

      $win.on("load resize scroll", function () {
        $mainHeight = $("main").offset().top + $("main").height();
        $breakpoint = $mainHeight - $win.height();

        if ($win.scrollTop() > $breakpoint) {
          var $diff = $win.scrollTop() - $breakpoint,
            $newPos = $bottomPos + $diff;

          $item.css("bottom", $newPos + "px");
        } else {
          $item.css("bottom", $bottomPos + "px");
        }
      });
    }
  })();
});
//setmessage plugin -r
(function ($) {
    $.fn.setMessage = function (options) {
      if ($.fn.setMessageNew !== undefined) {
        return $('.popup-msg').setMessageNew(options);
    }

    var settings = $.extend(
      {
        type: "error",
        message: null,
      },
      options
    );

    var $this = $(this),
      $errorMsgs = $(".messagebox", this);

    (function init() {
      var message = new Message($this);
      message.create();

      if ($errorMsgs.length > 0) {
        message.addSpacing();
      }

      if ($errorMsgs.length >= 3) {
        $.each($errorMsgs.slice(0, $errorMsgs.length - 2), function (index) {
            $($errorMsgs[index]).delay(1000).animate({ left: "-100%" }, 500, function () { $($errorMsgs[index]).remove(); })
        });
      }
    })();

    this.clearErrors = function () {
      if ($.fn.setMessageNew !== undefined) 
        $('.messagebox', '.popup-msg').remove();
      else
        $("#jsboxTempMssage").children().remove();
    };

    function Message($this) {
      this.$this = $this;
      this.create = function () {
        this.$messageBox = $('<div class="messagebox"></div>');
        this.$messageBox.addClass(settings.type);
        this.$messageBox.append(
          '<i class="material-icons left">announcement</i><span>' +
            settings.message +
            "</span>"
        );
        this.$closeMessage = $('<i class="material-icons right">clear</i>');
        this.$messageBox.append(this.$closeMessage);
        this.$this.append(this.$messageBox);

        this.addHandlers(this.$messageBox);
        this.addDelay();
      };
      this.addDelay = function () {
        this.$messageBox.delay(1000).animate(
          {
            left: "0px",
          },
          500
        );
      };
      this.addSpacing = function () {
        this.$messageBox.css("margin-top", "20px");
      };
      this.addHandlers = function (parent) {
        this.$closeMessage.click(function () {
          parent.animate(
            {
              left: "-100%",
            },
            500,
            function () {
              parent.remove();
            }
          );
        });
      };
    }
    return this;
  };
})(jQuery);

window.addEventListener("load", function () {
  var elements = document.querySelectorAll(
    ".grid-stack-tiem-content-to-repair"
  );

  // CHANGED FOR IE COMPABILITY

  for (var i = 0; i < elements.length; i++) {
    elements[i].parentNode.style.setProperty("bottom", "auto", "important");
  }

  /*
    elements.forEach(function(e) {
        e.parentNode.style.setProperty('bottom', 'auto', 'important')
    })*/
});

$(function () {
  var invoked = false;
  var targetNode = document.getElementById("headerCardPanel");

  //console.log('targetNode', targetNode);

  function callbackObserver(disconnect) {
    if (!invoked) {
      var medal = document.querySelector(
        ".userAvatar.medal.medal--show-mobile"
      );
      invoked = medal !== null;
      //console.log(medal);

      if (medal) {
        medal.addEventListener("click", function () {
          setTimeout(function () {
            var medalMenu = document.querySelector("#medalMenu");
            var left = parseFloat(medalMenu.style.left);

            if (left > 0) {
              medalMenu.classList.remove("expand-menu--over-width");
            } else {
              medalMenu.classList.add("expand-menu--over-width");
            }
          }, 0);
        });
      }
    }

    //console.log('observer handle invoked');

    if (disconnect) {
      observer.disconnect();
    }
  }

  callbackObserver(false);

  var observer = new MutationObserver(callbackObserver);

  //console.log('observer', observer);

  // Start observing the target node for configured mutations
  if (targetNode != null) {
      observer.observe(targetNode, {
          childList: true,
          subtree: true,
          attributes: true,
      });
  }
});

function flexTableScrollFix() {
  var table = document.querySelectorAll(".flex-table");

  for (var i = 0; i < table.length; i++) {
    var header = table[i].querySelector(".flex-table__header");
    var body = table[i].querySelector(".flex-table__body");
    var headerW = header.scrollWidth;
    var bodyW = body.scrollWidth;

    if (headerW > bodyW) {
      header.style.paddingRight = headerW - bodyW + "px";
    }
  }
}

window.addEventListener("load", function () {
  flexTableScrollFix();
});

$(document).ajaxComplete(function () {
  flexTableScrollFix();
});

$(document).ajaxComplete(function () {
  $(".roboticket-simple-tree-caret").on("click", function () {
    $(this).toggleClass("roboticket-simple-tree-active");
  });
});

$(function initSwiper() {
  const swiper = new Swiper(".swiper", {
    loop: true,
    speed: 400,
    autoplay: {
      delay: 3000,
    },
  });
});
